import * as React from 'react'
import * as style from './index.module.css'
import { SERVICE } from '@/utils/const'

/**
 * Service
 */
export const Service = (): React.JSX.Element => {
  return (
    <>
      <h2 className={style.serviceHeading}>事業内容</h2>
      {SERVICE.map((service) => (
        <div className={style.serviceContent} key={service.title}>
          <p className={style.serviceTitle}>{service.title}</p>
          <p className={style.serviceDescription}>{service.description}</p>
        </div>
      ))}
    </>
  )
}
